import { Toaster, UiStoreRoot } from '@pcrm/fe/ui-kit';
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { bindSessionExpiry, expireSessionOnUnauthorized } from './features/auth/session-expiry';
import { routeTree } from './routeTree.gen';
import './styles.css';

// Un 401 venit de la orice cerere înseamnă că sesiunea nu mai e bună — indiferent care
// ecran a făcut cererea. Tratat aici, o dată, nu în fiecare `onError`: altfel ecranul
// rămâne pe loc și pictează „Sesiunea a expirat" ca pe o eroare de conținut, fără să ducă
// nicăieri (tichetul #48). Vezi `features/auth/session-expiry.ts`.
const queryClient = new QueryClient({
  queryCache: new QueryCache({ onError: expireSessionOnUnauthorized }),
  mutationCache: new MutationCache({ onError: expireSessionOnUnauthorized }),
});

// `queryClient` intră în contextul rutelor: `beforeLoad`-ul stratului `_authenticated`
// cere sesiunea prin el, deci trebuie să fie **același** client cu cel al componentelor.
// Cu două instanțe, ruta ar vedea sesiunea și UI-ul n-ar vedea-o.
const router = createRouter({ routeTree, context: { queryClient } });

// Ultima piesă a cablajului de mai sus: cache-ul are nevoie de router ca să redirecționeze,
// routerul are nevoie de client ca să încarce. Legate prin import direct ar fi un ciclu.
bindSessionExpiry({ queryClient, router });

// Tipizarea rutelor: fără asta, `<Link to="/ceva-inexistent">` ar compila.
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const container = document.getElementById('root');
if (!container) {
  throw new Error('Elementul #root lipsește din index.html.');
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* Aplică tema și direcția pe `<html>` și ascultă `⌘K` / `Ctrl+K`. Trebuie să
          înconjoare routerul: paleta de comenzi citește aceeași stare. */}
      <UiStoreRoot>
        <RouterProvider router={router} />
        {/* Confirmările de salvare apar aici. Montat o dată, la rădăcină: un `Toaster`
            per ecran ar suprapune mai multe stive de notificări. */}
        <Toaster />
      </UiStoreRoot>
    </QueryClientProvider>
  </StrictMode>,
);
